import React from 'react';

import {Container} from './GamesGrid.styles';

import ContentBox from '../ContentBox';

function GamesGrid({
    items,
    featured,
    hidePlayButton,
    onClickItem,
    infinite,
    previewAmount,
}) {
    return (
        <Container id="games-grid">
            {infinite &&
                [...items, ...items]
                    .slice(-previewAmount)
                    .map((item, index) => {
                        return (
                            <ContentBox
                                key={`infinite_prev_${item.id}_${index}`}
                                id={item.id}
                                data={item}
                                featured={featured}
                                hideFavouriteButton
                                hidePlayButton
                                background={item.image}
                                title={item.showName}
                                sub={item.title}
                                type="game"
                                action={() => onClickItem(item.id, item)}
                            />
                        );
                    })}
            {items.map((item, index) => {
                return (
                    <ContentBox
                        key={item.id}
                        id={item.id}
                        data={item}
                        featured={featured}
                        hideFavouriteButton
                        hidePlayButton={hidePlayButton}
                        background={item.image}
                        title={item.title}
                        sub={item.showName}
                        type="game"
                        action={() => onClickItem(item.id, item)}
                    />
                );
            })}
            {infinite &&
                [...items, ...items]
                    .slice(0, previewAmount)
                    .map((item, index) => {
                        return (
                            <ContentBox
                                key={`infinite_after_${item.id}_${index}`}
                                id={item.id}
                                data={item}
                                featured={featured}
                                hideFavouriteButton
                                hidePlayButton
                                background={item.image}
                                title={item.showName}
                                sub={item.title}
                                type="game"
                                action={() => onClickItem(item.id, item)}
                            />
                        );
                    })}
        </Container>
    );
}

export default GamesGrid;
